import { isDeliveryIndividual, isDeliveryPersonal, isDeliverySelected } from "../../../../helpers/deliveryHelpers.ts";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppSelector } from "../../../../services/hooks.ts";
import { formatPrice } from "../../../../helpers/formatPrice.tsx";
import { DeliveryType } from "../../../../stores/cart/cartSlice.types.ts";
import { useTranslation } from "react-i18next";

export default function SiteSummaryDelivery() {
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption);

    return (
        !isDeliverySelected(activeDelivery)
            ? <SiteSummaryDeliveryNotSelected />
            : <SiteSummaryDeliverySelected />
    )
}

function SiteSummaryDeliveryNotSelected() {
    const { t } = useTranslation('cart');

    return (
        <Row>
            <Col sm={4} className="text-start">
                <strong>{t('summary.delivery.header')}:</strong>
            </Col>
            <Col>
                {t('summary.delivery.unselected')}
            </Col>
        </Row>
    );
}

function SiteSummaryDeliverySelected() {
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption);

    return (
        isDeliveryPersonal(activeDelivery)
            ? <SiteSummaryDeliveryPersonal />
            : (isDeliveryIndividual(activeDelivery)
                ? <SiteSummaryDeliveryIndividual />
                : <>
                    {activeDelivery.packages !== null && <SiteSummaryDeliveryCourier method={'packages'} />}
                    {activeDelivery.pallets !== null && <SiteSummaryDeliveryCourier method={'pallets'} />}
                </>
            )
    );
}

function SiteSummaryDeliveryIndividual() {
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption.individual);
    const { t } = useTranslation('cart');

    if (activeDelivery === null) return '';

    return (
        <Row>
            <Col sm={4} className="text-start">
                <strong>{t('summary.delivery.header')}:</strong>
            </Col>
            <Col>{t('summary.delivery.individual')}</Col>
        </Row>
    );
}

function SiteSummaryDeliveryPersonal() {
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption.personal);
    const deliveryOptions = useAppSelector((state) => state.cart.deliveryOptions.personal);
    const { t } = useTranslation('cart');

    if (activeDelivery === null) return '';

    return (
        <Row>
            <Col sm={4} className="text-start">
                <strong>{t('summary.delivery.header')}:</strong>
            </Col>
            <Col>{deliveryOptions[activeDelivery]['courier']}</Col>
        </Row>
    );
}

function SiteSummaryDeliveryCourier({ method }: { method: DeliveryType }) {
    const currency = useAppSelector((state) => state.user.currency);
    const activeDelivery = useAppSelector((state) => state.cart.activeDeliveryOption[method]);
    const deliveryOptions = useAppSelector((state) => state.cart.deliveryOptions[method]);
    const { t } = useTranslation('cart');

    // TODO: Fix na to musi być
    if (typeof activeDelivery !== 'number') return '';
    if (typeof deliveryOptions === 'boolean') return '';
    if (!deliveryOptions || typeof deliveryOptions[activeDelivery] === 'undefined') return '';

    return (
        <Row>
            <Col className="text-start">
                {method === 'packages' && <i className={'bi bi-box-seam fs-5'} />}
                &nbsp;
                <strong>{t('summary.delivery.header')} {deliveryOptions[activeDelivery]["courier"]}:</strong><br />
            </Col>
            <Col>
                {formatPrice(deliveryOptions[activeDelivery]["priceGross"] / 100, currency)} brutto<br />
                <small>{formatPrice(deliveryOptions[activeDelivery]["priceNet"] / 100, currency)} netto</small>
            </Col>
        </Row>
    );
}